import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { otp } from "../../api/apiClient";
import {
  getApplicantInfo,
  getProspectId,
  getAuthorizationHeader,
  isComebackJourney,
  getDeviceID
} from "../selectors/appConfig";
import {
  setGeneratingCode,
  generateCodeSuccess,
  verifyCodeSuccess,
  verifyCodeFailed,
  setOtpPendingRequest,
  GENERATE_OTP_CODE,
  VERIFY_OTP
} from "../actions/otp";
import { updateComeBackStatus, getPostLoginTokenPromisify } from "../actions/appConfig";
import { log } from "../../utils/loggger";
import { parseJwt } from "../../utils/genericUtils";

export function* generateOtp(action) {
  try {
    const { headers } = yield select(getAuthorizationHeader);
    headers["stage-id"] = "generateOtp";
    const prospectId = yield select(getProspectId);
    yield call(otp.generate, { ...action.payload, prospectId }, { headers });
    yield put(generateCodeSuccess());
  } catch (error) {
    log(error);
  } finally {
    yield put(setGeneratingCode(false));
  }
}

export function* verifyOtp(action) {
  try {
    const { headers } = yield select(getAuthorizationHeader);
    const DEVICE_ID = yield select(getDeviceID);
    headers["stage-id"] = "verifyOtp";
    const applicantInfo = yield select(getApplicantInfo);
    const prospectId = yield select(getProspectId);
    const comebackJourney = yield select(isComebackJourney);
    const { deviceId: uniqueId = "" } = parseJwt(headers.Authorization);

    const { code, mode = "sms" } = action.payload || {};
    const requestPayload = {
      email: applicantInfo.email,
      prospectId,
      mobileNo: applicantInfo.mobileNo,
      countryCode: applicantInfo.countryCode,
      otpToken: code,
      deviceId: DEVICE_ID,
      mode,
      uniqueId
    };
    const { data } = yield call(otp.verify, requestPayload, { headers });
    if (data.verified) {
      if (!comebackJourney) {
        yield put(getPostLoginTokenPromisify(prospectId));
        yield put(updateComeBackStatus(false));
      }
      yield put(verifyCodeSuccess());
    } else {
      yield put(verifyCodeFailed());
    }
  } catch (error) {
    log(error);
  } finally {
    yield put(setOtpPendingRequest(false));
  }
}

export default function* otpSagas() {
  yield all([takeLatest(GENERATE_OTP_CODE, generateOtp), takeLatest(VERIFY_OTP, verifyOtp)]);
}
